<div class="form-field">
  <fieldset [class.disabled]="disabled" [ngClass]="{'ng-invalid': !selectedOptionLabel && required}">
    <!-- Trigger / Origin -->
    <div cdkOverlayOrigin #origin="cdkOverlayOrigin" class="selected-trigger">
      <input type="text"
             [name]="name || label"
             [required]="required"
             [ngModel]="selectedOptionLabel"
             (ngModelChange)="onChange($event)"
             (click)="handleSelectedClick(origin)"
             placeholder="Select"
             (blur)="onTouched()"
             #selectRef="ngModel"
             readonly />
    </div>

    <!-- Overlay Panel -->
    <ng-template cdk-connected-overlay
                 [cdkConnectedOverlayOrigin]="origin"
                 [cdkConnectedOverlayOpen]="isOpen && !disabled"
                 [cdkConnectedOverlayPositions]="overlayPositions"
                 [cdkConnectedOverlayHasBackdrop]="true"
                 [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
                 [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
                 [cdkConnectedOverlayFlexibleDimensions]="true"
                 [cdkConnectedOverlayGrowAfterOpen]="true"
                 (backdropClick)="closeDropdown()"
                 (detach)="onOverlayDetach()"
                 (attach)="onOverlayAttach(origin)">

      <!-- Stop bubbling so inside-clicks don’t look like outside clicks anywhere -->
      <div class="dropdown-panel"
           [style.width.px]="triggerWidth"
           (mousedown)="$event.stopPropagation()"
           (click)="$event.stopPropagation()">

        <!-- Fixed Search Bar -->
        <div class="dropdown-search-bar">
          <input #searchInput
                 class="search-in-select"
                 type="search"
                 placeholder="Search..."
                 [(ngModel)]="searchTerm"
                 [disabled]="disabled"
                 [ngModelOptions]="{standalone: true}"
                 autocomplete="off"
                 (keydown)="onSearchKeydown($event)"
                 (click)="$event.stopPropagation()" />
        </div>

        <!-- Virtualized Options -->
        <cdk-virtual-scroll-viewport class="dropdown-options-scrollable"
                                     [itemSize]="optionHeight"
                                     [style.height.px]="panelHeight"
                                     (keydown.escape)="closeDropdown()">

          <div *cdkVirtualFor="let option of filteredOptions; let i = index; trackBy: trackByValueKey"
               class="dropdown-option"
               role="option"
               [attr.aria-selected]="i === activeIndex"
               [class.active]="i === activeIndex"
               (mousemove)="activeIndex = i"
               (click)="selectOption(option)">
            {{ option[labelKey] }}
          </div>

          <div *ngIf="filteredOptions.length === 0" class="dropdown-option">
            No Options From Search...
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </ng-template>

    <legend>{{ label }}</legend>
  </fieldset>
</div>
